import { useQuery } from "@tanstack/react-query";

import { useSignalsApiStatusPollingQuery } from "app/pages/sales-intelligence/modules/management/sub-modules/signals-api/query/queries/useSignalsApiStatusPollingQuery";
import salesApiService from "app/pages/sales-intelligence/services/salesApiService";

import { managementSubscribeDomainsQueryKeys } from "../key-factory/queryKeyFactory";

export const useSubscribeDomainsFileUrlQuery = () => {
    const { data } = useSignalsApiStatusPollingQuery();
    return useQuery({
        staleTime: Number.POSITIVE_INFINITY,
        queryKey: managementSubscribeDomainsQueryKeys.getUrl(),
        enabled: !!data?.domainsUpdateDate,
        queryFn({ signal }) {
            return salesApiService.management.downloadUrl();
        },
    });
};
